<template>
  <el-form
      ref="form"
      :model="form"
      label-width="180px">
    <el-radio-group
        v-model="form.bidStrategyType">
      <el-radio
          :label="AdBidStrategyTypeEnum.LEGACY_FOR_SALES">
        动态竞价-只降低
        <div class="bid-type-help">
          当您的广告不太可能带来销售时，我们将实时降低您的竞价。 在 2019 年 01 月之前创建的任何广告活动都会使用此设置。
        </div>
      </el-radio>
      <el-radio
          :label="AdBidStrategyTypeEnum.AUTO_FOR_SALES"
          class="block-radio">
        动态竞价-提高和降低
        <div class="bid-type-help">当您的广告很有可能带来销售时，我们将实时提高您的竞价（最高可达 100%），并在您的广告不太可能带来销售时降低您的竞价。</div>
      </el-radio>
      <el-radio
          :label="AdBidStrategyTypeEnum.MANUAL"
          class="block-radio">
        固定竞价
        <div class="bid-type-help">我们将使用您的确切竞价和您设置的任何手动调整，而不会根据售出可能性对您的竞价进行更改。</div>
      </el-radio>
      <div class="picker-wrapper">
        <el-collapse v-model="collapse">
          <el-collapse-item name="first">
            <template #title>
              <div class="location-bid">
                根据广告位调整竞价
                <gj-help>
                  通过输入相对默认竞价提高的百分比，按广告位应用不同竞价。这些调整将应用于广告活动中的所有竞价。您的竞价可以进一步更改，具体取决于您的竞价策略。
                </gj-help>
                <div class="location-bid--tip">除了竞价策略外，您可以将竞价提高多达 900%。</div>
              </div>
            </template>
            <el-form-item
                label="搜索结果顶部（首页）"
                class="chunk-input"
                prop="homePercentage"
                :rules="[
                   $gjReRule(RE.pt0, '请输入0~900整数值')
                ]">
              <gj-input
                  v-model="form.homePercentage"
                  width="150px"
                  @input="valInput($event, 'homePercentage')">
                 <template #append>%</template>
              </gj-input>
              <span class="input-example">示例：{{ homePercentageExample }}</span>
            </el-form-item>
            <el-form-item
                label="商品页面"
                class="chunk-input"
                prop="productPercentage"
                :rules="[
                   $gjReRule(RE.pt0, '请输入0~900整数值')
                ]">
              <gj-input
                  v-model="form.productPercentage"
                  width="150px"
                  @input="valInput($event, 'productPercentage')">
                <template #append>%</template>
              </gj-input>
              <span class="input-example">示例：{{ productPercentageExample }}</span>
            </el-form-item>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-radio-group>
  </el-form>
</template>

<script>
  import { formMixin, formRuleMixin } from "@/minxins";
  import { AdBidStrategyTypeEnum } from "modules/ad/common/enum";

  export default {
    name: "app-bid-strategy-picker",
    mixins: [formMixin, formRuleMixin],
    created() {
    },
    data() {
      return {
        AdBidStrategyTypeEnum,
        collapse: []
      }
    },
    computed: {
      homePercentageExample () {
        if(!this.form.bidStrategyType) { return '-' }
        let homePercentage = isNaN(Number(this.form.homePercentage)) ? 0 : Number(this.form.homePercentage)/100;
        const example = {
          [this.AdBidStrategyTypeEnum.LEGACY_FOR_SALES]: () => {
            if (homePercentage <= 0) { return "对于此广告位，$1竞价将保持 $1 不变。" }
            let bid = 1 + 1*homePercentage;
            return `对于此广告位，$1竞价将为 $${ bid.toFixed(2) }。`
          },
          [this.AdBidStrategyTypeEnum.AUTO_FOR_SALES]: () => {
            if (homePercentage <= 0) { return "对于此广告位，$1 竞价将为 $1。动态竞价可以将其提高至 $2" }
            let bid = 1 + 1*homePercentage;
            let bid1 = (1 + 1*homePercentage)*2;
            return `对于此广告位，$1竞价将为 $${ bid.toFixed(2) }。动态竞价可以将其提高至 $${ bid1.toFixed(2) }`
          },
          [this.AdBidStrategyTypeEnum.MANUAL]: () => {
            if (homePercentage <= 0) { return "对于此广告位，$1竞价将保持 $1 不变。" }
            let bid = 1 + 1*homePercentage;
            return `对于此广告位，$1竞价将为 $${ bid.toFixed(2) }。`
          },
        }
        return example[this.form.bidStrategyType]()
      },
      productPercentageExample () {
        if(!this.form.bidStrategyType) { return '-' }
        let productPercentage = isNaN(Number(this.form.productPercentage)) ? 0 : Number(this.form.productPercentage)/100;
        const example = {
          [this.AdBidStrategyTypeEnum.LEGACY_FOR_SALES]: () => {
            if (productPercentage <= 0) { return "对于此广告位，$1竞价将保持 $1 不变。" }
            let bid = 1 + 1*productPercentage;
            return `对于此广告位，$1竞价将为 $${ bid.toFixed(2) }。`
          },
          [this.AdBidStrategyTypeEnum.AUTO_FOR_SALES]: () => {
            if (productPercentage <= 0) { return "对于此广告位，$1 竞价将为 $1。动态竞价可以将其提高至 $1.5" }
            let bid = 1 + 1*productPercentage;
            let bid1 = (1 + 1*productPercentage)*1.5;
            return `对于此广告位，$1竞价将为 $${ bid.toFixed(2) }。动态竞价可以将其提高至 $${ bid1.toFixed(2) }`
          },
          [this.AdBidStrategyTypeEnum.MANUAL]: () => {
            if (productPercentage <= 0) { return "对于此广告位，$1竞价将保持 $1 不变。" }
            let bid = 1 + 1*productPercentage;
            return `对于此广告位，$1竞价将为 $${ bid.toFixed(2) }。`
          },
        }
        return example[this.form.bidStrategyType]()
      }
    },
    methods: {
      valInput(val, type) {
          val > 900 && (this.form[type] = 900);
      },
      formValidate() {
        return new Promise((resolve, reject) => {
          this.$refs.form.validate(valid => {
            if (!valid) {
              this.collapse = ['first'];
            }
            valid ? resolve() : reject()
          });
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "bid-picker";
  
  .block-radio {
    display: block;
  }
  
  .block-radio {
    margin-top: 16px;
  }
  
  .picker-wrapper {
    margin-top: 5px;
    margin-left: 24px;
    position: relative;
  }
  
  /deep/ .el-collapse,
  /deep/ .el-collapse-item__header,
  /deep/ .el-collapse-item__wrap {
    border: none;
  }
  
  /deep/ .el-collapse-item__arrow {
    position: absolute;
    left: -24px;
    top: 15px;
    font-size: 13px;
    font-weight: bold;
  }
  
  /deep/ .el-collapse-item__content {
    margin-top: 20px;
    padding-bottom: 0;
  }
  
  .location-bid {
    line-height: normal;
    margin-top: 19px;
  }
  
  .location-bid--tip {
    font-size: 12px;
    color: #909399;
    margin-top: 5px;
  }
  .input-example {
    padding-left: 9px;
    color: #909399;
  }

</style>


